import searchFederationUsers from './searchFederationUsers';
import { api } from '..';
import addUser from './addUser';

export const federationApis = api.injectEndpoints({
  endpoints: (build) => ({
    searchFederationUsers: searchFederationUsers(build),
    addUser: addUser(build),
  }),
  overrideExisting: true,
});

export const { useLazySearchFederationUsersQuery, useAddUserMutation } = federationApis;
